import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "depth-chart-container__content" }

import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { authService } from '@exchange/libs/auth/service/src';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { marketService, MarketState } from '@exchange/libs/market/service/src';
import { useOrderbook } from '@exchange/libs/orderbook/service/src';
import MarketOverlay from '@exchange/libs/overlays/MarketOverlay.vue';

import DepthChart from './DepthChart.vue';
import useDepthChart from './useDepthChart';


export default /*#__PURE__*/_defineComponent({
  __name: 'DepthChartContainer',
  props: {
  marketId: { type: String, required: true },
  showTitle: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;

const { marketId } = toRefs(props);

const { t } = useI18n({ useScope: 'global' });
const { isXS } = useMQBreakpoints();

const { getMarket, getMarketPrecision, getMarketName, getMarketState } = marketService;

const market = computed(() => getMarket(marketId.value));
const marketState = computed(() => getMarketState(market.value));
const marketName = computed(() => getMarketName(market.value));
const marketPrecisions = computed(() => getMarketPrecision(market.value));

const depthChartOverlayFor = computed(() => (isXS.value ? [MarketState.NEW] : []));
const showDepthChartOverlay = computed(() => marketState.value && depthChartOverlayFor.value.includes(marketState.value));
const { orderbook, orderbookIsLoading } = useOrderbook(marketId);
const hasBeenAuthenticated = computed(() => authService.hasBeenAuthenticated);

const { showLoading, onRendererReady } = useDepthChart(orderbookIsLoading);

const title = computed(() => {
  if (!isXS.value) {
    return t('modules.tradingChart.tabs.depthChart');
  }

  return undefined;
});

return (_ctx: any,_cache: any) => {
  const _component_ot_module_container = _resolveComponent("ot-module-container")!

  return (_openBlock(), _createBlock(_component_ot_module_container, {
    class: "depth-chart-container",
    loading: _unref(showLoading),
    title: __props.showTitle ? title.value : ''
  }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (showDepthChartOverlay.value)
          ? (_openBlock(), _createBlock(MarketOverlay, {
              key: 0,
              "market-name": marketName.value,
              "market-state": marketState.value,
              "has-been-authenticated": hasBeenAuthenticated.value
            }, null, 8, ["market-name", "market-state", "has-been-authenticated"]))
          : _createCommentVNode("", true),
        (market.value && _unref(orderbook))
          ? (_openBlock(), _createBlock(DepthChart, {
              key: 1,
              "market-id": _unref(marketId),
              "market-base-code": market.value && market.value.base.code,
              "amount-precision": marketPrecisions.value.amount,
              "market-precision": marketPrecisions.value.market,
              orderbook: _unref(orderbook),
              onRendererReady: _unref(onRendererReady)
            }, null, 8, ["market-id", "market-base-code", "amount-precision", "market-precision", "orderbook", "onRendererReady"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "title"]))
}
}

})